import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const location = useLocation();
    
    return (
        <header className="app-header">
            <div className="header-content">
                <h1 className="header-title">HR Integration Manager</h1>
                <nav className="nav-bar">
                    <Link 
                        to="/" 
                        className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                    >
                        Create Integration
                    </Link>
                    <Link 
                        to="/active-integrations" 
                        className={`nav-link ${location.pathname === '/active-integrations' ? 'active' : ''}`}
                    >
                        Active Integrations
                    </Link>
                </nav>
            </div>
        </header>
    );
};

export default Header;